<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Cash Break Solver - Advanced Settings</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div
  class="modal-body"
  [formGroup]="advancedSettingsForm"
  hsDraggable="modal-dialog"
>
  <div class="preserve-default-toggle">
    <nf-checkbox
      formControlName="preserveNonDefaultSettings"
      label="Preserve Non-Default Settings"
    >
    </nf-checkbox>
  </div>
  <div class="advanced-settings-toggles">
    <ng-container>
      <nf-checkbox
        formControlName="unmatchedExtTransactions"
        label="Include Unmatched External Transactions"
      >
      </nf-checkbox>
      <nf-checkbox
        formControlName="ignoredExtTransactions"
        label="Include Ignored External Transactions"
      >
      </nf-checkbox>
      <nf-checkbox
        formControlName="unmatchedUnclearedCwTx"
        label="Include Unmatched Uncleared Clearwater Transactions"
      >
      </nf-checkbox>
      <nf-checkbox
        formControlName="clearedCashTransactions"
        label="Include Cleared CASH Transactions"
      >
      </nf-checkbox>
      <nf-checkbox
        formControlName="clearedMmfTrades"
        label="Include Cleared MMF Trades"
      >
      </nf-checkbox>
    </ng-container>
  </div>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button (click)="resetToDefault()">Reset to Default</button>
  <div class="button-group-right">
    <button nf-button="cancel" (click)="activeModal.close(undefined)">
      Cancel
    </button>
    <button nf-button="primary" (click)="runSolver()">Run Solver</button>
  </div>
</div>
